import { render, staticRenderFns } from "./VxDrawer.vue?vue&type=template&id=5938682b"
import script from "./VxDrawer.vue?vue&type=script&lang=js"
export * from "./VxDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports